// Penentuan tipe file dokumen (PDF / EPUB) berdasarkan ekstensi nama file.
//
// `file.type` diisi browser dari sistem operasi, bukan dari isi file:
// - macOS mengenal EPUB  -> 'application/epub+zip'
// - Windows membaca registry (HKEY_CLASSES_ROOT\.epub) yang sering kosong / ditimpa aplikasi lain
//   -> '' atau tipe lain, dan saat upload terkirim sebagai 'application/octet-stream'.
// Karena itu validasi & Content-Type saat upload jangan bergantung pada `file.type`.

export const DOCUMENT_MIME_TYPES = {
  pdf: 'application/pdf',
  epub: 'application/epub+zip',
};

export const getFileExtension = (fileName = '') => {
  const dotIndex = fileName.lastIndexOf('.');
  return dotIndex > -1 ? fileName.slice(dotIndex + 1).trim().toLowerCase() : '';
};

// 'application/pdf' | 'application/epub+zip' | null (bukan PDF/EPUB)
export const getDocumentMimeType = (file) => DOCUMENT_MIME_TYPES[getFileExtension(file?.name)] || null;

export const isDocumentFile = (file) => Boolean(getDocumentMimeType(file));

// Kembalikan File dengan MIME type yang benar sesuai ekstensi, agar Content-Type yang dikirim ke
// server sama di Windows maupun Mac. File asli dikembalikan apa adanya bila tipenya sudah benar
// atau bukan dokumen PDF/EPUB.
export const withDocumentMimeType = (file) => {
  const type = getDocumentMimeType(file);
  if (!type || file.type === type) return file;

  return new File([file], file.name, { type, lastModified: file.lastModified });
};
